var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import getElementWidthHoc from '../../hoc/getElementWidthHoc';
var AutoTruncatedLabel = /** @class */ (function (_super) {
    __extends(AutoTruncatedLabel, _super);
    function AutoTruncatedLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.element = null;
        _this.resize = _this.resize.bind(_this);
        _this.state = { showTooltip: false };
        return _this;
    }
    AutoTruncatedLabel.prototype.componentDidMount = function () {
        this.resize(this.props.width);
    };
    AutoTruncatedLabel.prototype.componentDidUpdate = function () {
        this.resize(this.props.width);
    };
    AutoTruncatedLabel.prototype.resize = function (width) {
        if (width && this.element) {
            var showTooltip = this.element.offsetWidth > width;
            if (this.state.showTooltip !== showTooltip) {
                this.setState({ showTooltip: showTooltip });
            }
        }
    };
    AutoTruncatedLabel.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, className = _a.className, tooltip = _a.tooltip, id = _a.id;
        var showTooltip = this.state.showTooltip;
        return (React.createElement("div", null,
            (!!tooltip || showTooltip) &&
                React.createElement(ReactTooltip, { className: "accurity-tooltip", html: true, type: "dark", id: id }),
            React.createElement("div", { className: "autoTruncatedLabel" },
                React.createElement("span", { ref: function (r) { _this.element = r; }, "data-tip": tooltip || value, "data-for": id, className: classNames('label', className) }, value))));
    };
    return AutoTruncatedLabel;
}(React.Component));
export default getElementWidthHoc(AutoTruncatedLabel);
//# sourceMappingURL=AutoTruncatedLabel.js.map